export const FAQ_PATH = '/faqs';

export type AppRoute = 'home' | 'faq' | 'notFound';

export function matchRoute(pathname: string): AppRoute {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (normalized === '/' || normalized === '/index.html') return 'home';
  if (normalized === FAQ_PATH || normalized === '/faqs.html') return 'faq';
  return 'notFound';
}
